import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/landing/shape-1.png'
import _imports_1 from '@/assets/images/landing/shape-2.png'


const _hoisted_1 = {
  class: "unlock-area ptb-150 position-relative z-1",
  id: "admin"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "border-bottom pb-150" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "unlock-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Unlock a world of possibilities with Trezo Dashboard.", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, " Experience the difference with Trezo Dashboard. Sign up for a free trial today and see how our intuitive platform can revolutionize your data analysis process. ", -1)),
            _createVNode(_component_RouterLink, {
              to: "/contact",
              class: "btn btn-primary-div py-2 px-4 fs-16 fw-medium rounded-3 text-white"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "ri-user-line fs-18" }, null, -1),
                _createElementVNode("span", { class: "ms-1" }, "Get started - It is free", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_0,
      class: "shape shape-5",
      alt: "shape"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_1,
      class: "shape shape-6",
      alt: "shape"
    }, null, -1))
  ]))
}